import React, { useState, useEffect } from 'react';
import { SpotlightCard } from '@atlaskit/onboarding';

import { useLocalStorage } from '@/controllers';
import { popup } from '@/styles';
import { FCC } from '@/utils/types';

const ONBOARDING_STATUS_ACTIONED: string = 'actioned';

type OnboardingPopupProps = {
  onboardingKey: string;
};

const OnboardingPopup: FCC<OnboardingPopupProps> = ({ onboardingKey, children }) => {
  const [onboardingVisible, setOnboardingVisible] = useState(false);
  const [onboardingStatus, setOnboardingStatus] = useLocalStorage(onboardingKey, '');

  const handleRemove = () => {
    setOnboardingStatus(ONBOARDING_STATUS_ACTIONED);
    setOnboardingVisible(false);
  };

  useEffect(() => {
    if (onboardingStatus !== ONBOARDING_STATUS_ACTIONED) setOnboardingVisible(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!onboardingVisible) return <></>;

  return (
    <div css={[popup]}>
      <SpotlightCard
        actions={[
          {
            text: 'Dismiss',
            onClick: handleRemove,
            appearance: 'subtle',
          },
        ]}
      >
        {children}
      </SpotlightCard>
    </div>
  );
};

export default OnboardingPopup;
